"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FormPersonalization_AddAnApp: "Add an app",
            FormPersonalization_AddAnApp_ToolTip: "Select the area of the form you wish to add an app to. Then configure the app in the dialog that opens.",
            FormPersonalization_AddAPage: "Add a page",
            FormPersonalization_AddButton: "Add a field",
            FormPersonalization_AddButton_ToolTip: "Add a field that is not yet part of this page. Select a region to add a field to, and the add field slider will appear with field choices.",
            FormPersonalization_AddFieldMode: "Enable Insert a Field mode",
            FormPersonalization_AddMenu: "Insert",
            FormPersonalization_AddMenuToolTip: "Insert a control on the page",
            FormPersonalization_AddPA: "Add an app from Power Apps",
            FormPersonalization_AddPA_ToolTip: "Select the area of the form you wish to add a PowerApp to. Then configure the PowerApp in the dialog that opens.",
            FormPersonalization_AddPAControlMode: "Enable Insert a PowerApp mode",
            FormPersonalization_CanBePersonalized: "Can be personalized",
            FormPersonalization_CannotBePersonalized: "Cannot be personalized",
            FormPersonalization_Clear: "Clear personalization on this page",
            FormPersonalization_ClearButton: "Clear",
            FormPersonalization_CloseButton: "Close",
            FormPersonalization_Exit: "Exit personalization mode",
            FormPersonalization_Export: "Export personalization",
            FormPersonalization_ExportButton: "Export",
            FormPersonalization_HideButton: "Hide/View",
            FormPersonalization_HideButton_ToolTip: "Click elements you want to hide or make visible.",
            FormPersonalization_HideMode: "Enable Hide mode",
            FormPersonalization_Import: "Import personalization",
            FormPersonalization_ImportButton: "Import",
            FormPersonalization_IsPersonalized: "Has been personalized",
            FormPersonalization_LockButton: "Lock field",
            FormPersonalization_LockButton_ToolTip: "Select the fields to lock to prevent changes.",
            FormPersonalization_LockMode: "Enable Lock mode",
            FormPersonalization_MandatoryButton: "Require",
            FormPersonalization_MandatoryButton_ToolTip: "Select the fields you want to be required for data entry",
            FormPersonalization_MandatoryControlHidden: "You have hidden a required field. This field will be shown if it has no value when a save is attempted.",
            FormPersonalization_MoreButton: "More",
            FormPersonalization_MoreButton_ToolTip: "Add a PowerApp to this page, or clear, import, or export personalizations for this page",
            FormPersonalization_MoreButton_ToolTip_AppsFlight: "Add an app to this page, or clear, import, or export personalizations for this page",
            FormPersonalization_MoveButton: "Move",
            FormPersonalization_MoveButton_ToolTip: "Select an element and drag to a new location, or use tab and the arrow keys to choose the new location and space/enter to confirm.",
            FormPersonalization_MoveMode: "Enable Move mode",
            FormPersonalization_MoveNextTo: "Move next to {0}",
            FormPersonalization_PreviewButton: "Preview",
            FormPersonalization_RegionTitle: "Personalization toolbar",
            FormPersonalization_SelectButton: "Select",
            FormPersonalization_SelectButton_ToolTip: "Select an element to open a dialog and change its properties.",
            FormPersonalization_SelectedForMove: "Selected for move",
            FormPersonalization_SelectMode: "Enable Select mode",
            FormPersonalization_SkipButton: "Skip in tab",
            FormPersonalization_SkipButton_ToolTip: "Select the fields to be skipped when tabbing.",
            FormPersonalization_SkipMode: "Enable Skip mode",
            FormPersonalization_SummaryMode: "Enable Summary mode",
            FormPersonalization_TabSummaryButton: "Show in header",
            FormPersonalization_TabSummaryButton_ToolTip: "Select the fields to show in a collapsed section header.",
            FormPersonalization_ToggleFocus: "Toggle focus between the personalization toolbar and the page content",
            FormPersonalization_UnselectedForMove: "Unselected for move",
        }
    });
    $(window).on($dyn.forms.Events.personalize, function (evt) {
        // We handle this command client side so prevent the default action
        // and intiate the action.
        evt.preventDefault();
        $dyn.ax.formPersonalizationPane.formPersonalizationController.destroyQTip();
        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.LaunchToolbar();
    });
    var ax;
    (function (ax) {
        var personalizationMode;
        (function (personalizationMode) {
            personalizationMode["open"] = "open";
            personalizationMode["select"] = "select";
            personalizationMode["move"] = "move";
            personalizationMode["hide"] = "hide";
            personalizationMode["mandatory"] = "mandatory";
            personalizationMode["addToSummary"] = "addToSummary";
            personalizationMode["skip"] = "skip";
            personalizationMode["lock"] = "lock";
            personalizationMode["addAField"] = "addAField";
            personalizationMode["addPAControl"] = "addPAControl";
            personalizationMode["addApp"] = "addApp";
        })(personalizationMode = ax.personalizationMode || (ax.personalizationMode = {}));
        var personalizableProperties;
        (function (personalizableProperties) {
            personalizableProperties["AllowEdit"] = "AllowEdit";
            personalizableProperties["CanFocus"] = "CanFocus";
            personalizableProperties["FastTabSummary"] = "FastTabSummary";
            personalizableProperties["Mandatory"] = "PersonalizationMandatory";
            personalizableProperties["Visible"] = "Visible";
        })(personalizableProperties = ax.personalizableProperties || (ax.personalizableProperties = {}));
        ax.personalizationModeEventHandlers = {
            addAField: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForAdd(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForAdd(control);
                    }
                },
            },
            addApp: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForAddApp(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForAddApp(control);
                    }
                },
            },
            addPAControl: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForAddPAControl(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForAddPAControl(control);
                    }
                },
            },
            addToSummary: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForAddToSummary(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForAddToSummary(control);
                    }
                },
            },
            hide: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForHide(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForHide(control);
                    }
                },
            },
            lock: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForLock(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForLock(control);
                    }
                },
            },
            mandatory: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForMandatory(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForMandatory(control);
                    }
                },
            },
            move: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.upArrow,
                    $dyn.ui.KeyCodes.downArrow,
                    $dyn.ui.KeyCodes.leftArrow,
                    $dyn.ui.KeyCodes.rightArrow,
                    $dyn.ui.KeyCodes.tab,
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                    $dyn.ui.KeyCodes.esc,
                ],
                onClick: function (toolbar, control) {
                    toolbar.resetMove();
                    toolbar.resetPotentialTarget();
                    toolbar.SelectForMove(control);
                    toolbar.shouldTarget = true;
                    if (toolbar.dragTarget) {
                        var draggableObject = new Hammer(toolbar.dragTarget);
                        draggableObject.add(new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 }));
                        toolbar.isDragging = false;
                        toolbar.draggableObject = draggableObject;
                        draggableObject.on("pan", toolbar._handleDrag);
                    }
                },
                onKeyDown: function (toolbar, control, event) {
                    var propagate = true;
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.resetPotentialTarget();
                        toolbar.SelectForMove(control);
                        toolbar.shouldTarget = true;
                    }
                    else if (key === $dyn.ui.KeyCodes.esc) {
                        if (toolbar.selectedForMove) {
                            propagate = false;
                        }
                        toolbar.resetMove();
                    }
                    else {
                        toolbar.UpdateMoveToLocationKeyboard(event);
                    }
                    return propagate;
                },
                subTarget: function (toolbar, control, event) {
                    toolbar.UpdateMoveToLocation(control, event);
                },
            },
            select: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForQuickPersonalization(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForQuickPersonalization(control);
                    }
                },
            },
            skip: {
                acceptedKeyCodes: [
                    $dyn.ui.KeyCodes.enter,
                    $dyn.ui.KeyCodes.spacebar,
                ],
                onClick: function (toolbar, control) {
                    toolbar.SelectForSkip(control);
                },
                onKeyDown: function (toolbar, control, event) {
                    var key = event.which;
                    if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                        toolbar.SelectForSkip(control);
                    }
                },
            },
        };
        var formPersonalizationPane;
        (function (formPersonalizationPane) {
            formPersonalizationPane.paneName = "FormPersonalizationPane";
            formPersonalizationPane.formPersonalizationController = new $dyn.ax.formPersonalizationController();
            formPersonalizationPane.formPersonalizationToolbar = new $dyn.ax.formPersonalizationToolbar();
            formPersonalizationPane.qTipDestroyed = new $dyn.eventHost();
        })(formPersonalizationPane = ax.formPersonalizationPane || (ax.formPersonalizationPane = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
    var ui;
    (function (ui) {
        var personalizationClasses;
        (function (personalizationClasses) {
            personalizationClasses["canBePersonalized"] = "personalization-canBePersonalized";
            personalizationClasses["cannotBePersonalized"] = "personalization-cannotBePersonalized";
            personalizationClasses["dragClone"] = "personalization-dragClone";
            personalizationClasses["draggable"] = "ui-draggable";
            personalizationClasses["dragging"] = "ui-draggable-dragging";
            personalizationClasses["hidden"] = "personalized-hidden";
            personalizationClasses["isPersonalizing"] = "isPersonalizing";
            personalizationClasses["locked"] = "personalized-locked";
            personalizationClasses["mandatory"] = "personalized-mandatory";
            personalizationClasses["movePositionAfter"] = "personalization-movePositionAfter";
            personalizationClasses["movePositionBefore"] = "personalization-movePositionBefore";
            personalizationClasses["movePositionHorizontal"] = "personalization-movePositionHorizontal";
            personalizationClasses["personalized"] = "personalization-personalized";
            personalizationClasses["personalizedAsMandatory"] = "personalizedAsMandatory";
            personalizationClasses["personalizedElement"] = "personalization-personalizedElement";
            personalizationClasses["potentialTarget"] = "personalization-potentialTarget";
            personalizationClasses["selectedForMove"] = "personalization-selectedForMove";
            personalizationClasses["skipped"] = "personalized-skipped";
            personalizationClasses["summary"] = "personalized-summary";
        })(personalizationClasses = ui.personalizationClasses || (ui.personalizationClasses = {}));
        var personalizationModeSymbolClasses;
        (function (personalizationModeSymbolClasses) {
            personalizationModeSymbolClasses["Click"] = "Click-symbol";
            personalizationModeSymbolClasses["HideItem"] = "HideItem-symbol";
            personalizationModeSymbolClasses["Move"] = "Move-symbol";
            personalizationModeSymbolClasses["SkipTab"] = "SkipTab-symbol";
            personalizationModeSymbolClasses["SummaryField"] = "SummaryField-symbol";
            personalizationModeSymbolClasses["Uneditable"] = "Uneditable-symbol";
        })(personalizationModeSymbolClasses = ui.personalizationModeSymbolClasses || (ui.personalizationModeSymbolClasses = {}));
        var personalizationToolbarEvents;
        (function (personalizationToolbarEvents) {
            personalizationToolbarEvents["ActionOpen"] = "open";
            personalizationToolbarEvents["ActionSystemClose"] = "systemClose";
            personalizationToolbarEvents["ActionUserClose"] = "close";
            personalizationToolbarEvents["ToolbarClosed"] = "personalizationToolbarClosed";
        })(personalizationToolbarEvents = ui.personalizationToolbarEvents || (ui.personalizationToolbarEvents = {}));
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FormPersonalizationPane.js.map
